import Cookies from 'js-cookie'
import CookieConsent from './Types/CookieConsent'
import initDatalayer from './dataLayer'

function setCookie (cookieInputs) {
  const consent: Partial<CookieConsent> = {
    NECESSARY: true
  }

  const cookieSetter = Cookies.withConverter({
    write: function (value: any, name: string): string {
      if (name === 'CookieConsent') {
        return unescape(JSON.stringify(value))
      }

      return Cookies.converter.read(value, name)
    }
  })

  cookieInputs.forEach((input) => {
    consent[input.name] = input.checked as boolean
  })

  cookieSetter.set('CookieConsent', consent, { expires: 365 })
}

const initCookie = () => {
  const wrapper = document.querySelector('.cookiebanner')
  const overlay = document.querySelector('.cookiebanner--popout__container') as HTMLElement
  const editButton = wrapper.querySelector('.cookiebanner__button#cookie-adjust')
  const confirmButton = wrapper.querySelector('.cookiebanner__button#cookie-edit')
  const allowAllButton = wrapper.querySelector('.cookiebanner__button#confirm')
  const cookieInputs = wrapper.querySelectorAll('.cookiebanner-toggle__input') as NodeListOf<HTMLInputElement>

  const buttons = [
    editButton,
    confirmButton,
    allowAllButton
  ]

  buttons.forEach(button => {
    button.addEventListener('click', function (): void {
      setCookie(cookieInputs)
      initDatalayer(JSON.parse(Cookies.get('CookieConsent')))

      if (overlay !== null) {
        overlay.remove()
      } else {
        wrapper.remove()
      }
    })
  })
}

export default initCookie
